import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import clsx from 'clsx';
import { makeStyles } from '../../lib/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
  },
  icon: {
    width: 18,
    height: 18,
  },
  uncheckedIcon: {
    color: theme.palette.grey[300],
  },
}));

const Checkbox = forwardRef(function Checkbox(
  { className, color, onChange, disabled, required, checked, inputRef, ...restProps },
  ref
) {
  const { root, icon, uncheckedIcon } = useStyles();

  return (
    <MaterialCheckbox
      className={clsx(className, root)}
      ref={ref}
      checkedIcon={<CheckBoxIcon className={icon} />}
      icon={<CheckBoxOutlineBlankIcon className={clsx(icon, uncheckedIcon)} />}
      {...restProps}
      disableRipple
      required={required}
      onChange={onChange}
      disabled={disabled}
      color={color}
      checked={checked}
      inputRef={inputRef}
    />
  );
});

Checkbox.propTypes = {
  className: Proptypes.string,
  color: Proptypes.oneOf(['primary', 'secondary', 'default']),
  disabled: Proptypes.bool,
  onChange: Proptypes.func,
  required: Proptypes.bool,
  checked: Proptypes.bool,
  value: Proptypes.string,
  inputRef: Proptypes.oneOfType([Proptypes.func, Proptypes.object]),
};

Checkbox.defaultProps = {
  className: '',
  color: 'primary',
  disabled: false,
  onChange: null,
  required: false,
  checked: false,
  value: '',
  inputRef: null,
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
